module.exports = __webpack_public_path__ + "static/img/payok.999c2c78.svg";